import { findAll, isUnattached, setAttached } from "./dom";

const sync = (fieldset) => {
  const checked = fieldset.querySelector("[data-auth-toggle]:checked");
  const block = fieldset.querySelector("[data-auth-id-block]");
  const idField = fieldset.querySelector("[data-auth-id-field]");
  if (!block) return;

  const isAuthorized =
    checked && checked.getAttribute("data-auth-toggle") === "authorized";

  block.style.display = isAuthorized ? "" : "none";
  if (idField) {
    idField.required = !!isAuthorized;
    if (!isAuthorized) idField.value = "";
  }
};

const onChange = (event) => {
  if (!event.target.matches("[data-auth-toggle]")) return;
  const fieldset = event.target.closest("[data-auth-fieldset]");
  if (fieldset) sync(fieldset);
};

export default () =>
  findAll(document, "[data-auth-fieldset]")
    .filter((element) => isUnattached("auth-declaration", element))
    .map((element) => setAttached("auth-declaration", element))
    .forEach((element) => {
      element.addEventListener("change", onChange);
      sync(element);
    });
